import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsWorkOrderStatus, PmsWorkOrderStatus } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsWorkOrderStatus>
    useData={usePmsWorkOrderStatus}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
